export const brandInfo = {
  name: "开云体育",
  fullName: "开云体育官方平台",
  slogan: "安全 · 稳定 · 极速 — 您的一站式体育娱乐平台",
  founded: "2015年",
  description: "开云体育是亚洲领先的综合性体育娱乐平台，致力于为全球体育爱好者提供专业的赛事直播、赛事竞猜及会员福利服务。平台持有国际正规运营牌照，采用银行级安全加密技术，确保用户资金与信息安全。开云体育与多家国际顶级体育赛事机构建立长期合作关系，覆盖足球、篮球、电竞、网球等上百个体育项目，每日提供超过千场赛事竞猜服务。",
  mission: "以技术创新为驱动，以用户服务为核心，打造全球最受信赖的体育娱乐平台。",
  vision: "成为全球体育娱乐行业的标杆品牌，让每一位体育爱好者都能享受到公平、安全、极致的赛事体验。",
};

export const credentials = [
  {
    id: 1,
    icon: "ri-verified-badge-line",
    title: "国际运营牌照",
    description: "持有菲律宾PAGCOR、英国GC等国际权威机构颁发的合法运营牌照，接受严格监管与定期审计，确保平台合规经营。",
  },
  {
    id: 2,
    icon: "ri-lock-line",
    title: "银行级安全加密",
    description: "采用256位SSL加密技术与多重防火墙保护体系，所有用户数据传输均经过高强度加密，确保用户隐私与资金绝对安全。",
  },
  {
    id: 3,
    icon: "ri-shield-flash-line",
    title: "独立第三方审计",
    description: "平台游戏及竞猜系统定期接受国际权威第三方机构独立审计，确保所有赛事结果与竞猜结算的公平性与透明度。",
  },
  {
    id: 4,
    icon: "ri-hand-coin-line",
    title: "资金托管保障",
    description: "用户资金由合作银行机构进行独立托管，平台严格分离运营资金与用户资金，从根本上保障用户资金安全。",
  },
];

export const milestones = [
  { year: "2015", title: "品牌创立", description: "开云体育正式成立，获得首张国际运营牌照，开启体育娱乐事业新征程。" },
  { year: "2017", title: "业务拓展", description: "平台注册用户突破百万，业务覆盖亚洲多个国家和地区，成为区域领先的体育娱乐平台。" },
  { year: "2019", title: "技术升级", description: "全面升级技术架构，引入AI智能风控系统与大数据分析平台，进一步提升用户体验与安全性。" },
  { year: "2021", title: "全球化布局", description: "注册用户突破千万，业务拓展至全球128个国家和地区，成为国际化的体育娱乐品牌。" },
  { year: "2023", title: "品牌升级", description: "获得多项行业权威认证，推出全新品牌形象，会员服务体系全面升级。" },
  { year: "2025", title: "行业领先", description: "注册用户突破5000万，日均处理赛事超过千场，稳居亚洲体育娱乐平台前列。" },
];

export const contactInfo = {
  email: "service@kaiyunsports.com",
  phone: "+852 3008 8888",
  address: "香港中环金融街8号国际金融中心",
  workingHours: "7×24小时全年无休",
  socialLinks: [
    { name: "微信", icon: "ri-wechat-line", link: "#" },
    { name: "微博", icon: "ri-weibo-line", link: "#" },
    { name: "QQ", icon: "ri-qq-line", link: "#" },
  ],
};

export const faqs = [
  {
    question: "开云体育平台是否合法合规？",
    answer: "开云体育持有菲律宾PAGCOR、英国GC等国际权威机构颁发的合法运营牌照，严格遵守各国法律法规，平台运营完全合法合规。所有赛事竞猜活动均接受国际监管机构的定期审计与监督。",
  },
  {
    question: "如何注册成为开云体育会员？",
    answer: "访问开云体育官网，点击右上角'注册'按钮，按照页面提示填写手机号或邮箱、设置密码并完成验证即可轻松注册。注册过程仅需1-2分钟，新用户注册即享专属福利礼包。",
  },
  {
    question: "平台支持哪些支付方式？",
    answer: "开云体育支持多种便捷支付方式，包括银行卡、微信支付、支付宝、USDT数字货币等。充值即时到账，提现快速处理，平均提现速度仅需30秒左右。",
  },
  {
    question: "如何保障用户资金安全？",
    answer: "平台采用银行级256位SSL加密技术，用户资金由合作银行独立托管，严格分离运营资金与用户资金。同时配备AI智能风控系统，实时监测异常交易，全方位保障用户资金安全。",
  },
  {
    question: "竞猜结算是否公平透明？",
    answer: "所有赛事竞猜结果均以官方赛事数据为准，结算系统经过国际权威第三方机构独立审计，确保结算过程的公平性、准确性与透明度。用户可在个人中心随时查看竞猜记录与结算详情。",
  },
  {
    question: "遇到问题如何联系客服？",
    answer: "开云体育提供7×24小时全天候客服支持，您可以通过在线客服、官方邮箱service@kaiyunsports.com或客服热线+852 3008 8888联系我们。专业客服团队将在第一时间为您解答问题。",
  },
];